import * as sections from "components/Homeowner/CaseForms/ComparableGrid/Sections/Sections";
import { range } from "lodash";

export const getProximityValue = (subjectLatitude, subjectLongitude, compLatitude, compLongitude, proximity) => {
  let calculatedProximity = null;
  let dir = null;
  if (subjectLatitude && subjectLongitude && compLatitude && compLongitude) {
    calculatedProximity = getDistanceFromLatLonInMiles(subjectLatitude, subjectLongitude, compLatitude, compLongitude);
    dir = getDirectionFromLatLon(subjectLatitude, subjectLongitude, compLatitude, compLongitude);
  
    return {
      // proximity can be a string coz new comp grid will also save direction
      miles: calculatedProximity || (typeof (proximity) === "string" ? proximity.replace(/\D/g, "") : proximity),
      direction: dir,
      get displayValue() { return `${this.miles ? this.miles + " miles" : ""}${this.direction ? " " + this.direction : ""}`; },
      get postValue() { return `${this.miles ? this.miles : ""}${this.direction ? " " + this.direction : ""}`; }
    };
  } else {
    return { miles: "", direction: "", displayValue: "", postValue: "" };
  }
};

//https://stackoverflow.com/questions/11415106/issue-with-calcuating-compass-bearing-between-two-gps-coordinates
//https://www.igismap.com/formula-to-find-bearing-or-heading-angle-between-two-points-latitude-longitude/
export const getDirectionFromLatLon = (lat1, lon1, lat2, lon2) => {
  if (!(+lat1 && +lon1 && +lat2 && +lon2)) return null;
  let lat1rad = deg2rad(lat1);
  let lon1rad = deg2rad(lon1);
  let lat2rad = deg2rad(lat2);
  let lon2rad = deg2rad(lon2);
  let dLon = (lon2rad - lon1rad);
  let y = Math.sin(dLon) * Math.cos(lat2rad);
  let x = Math.cos(lat1rad) * Math.sin(lat2rad) - Math.sin(lat1rad) * Math.cos(lat2rad) * Math.cos(dLon);
  let brng = rad2deg(Math.atan2(y, x));
  return getCardinal((brng + 360) % 360);
};

// https://stackoverflow.com/questions/7490660/converting-wind-direction-in-angles-to-text-words/25867068#25867068
//given "0-360" returns the nearest cardinal direction "N/NE/E/SE/S/SW/W/NW/N" 
export const getCardinal = (angle) => {
  const directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
  return directions[Math.round(angle / 45) % 8];
};

export const getDistanceFromLatLonInMiles = (lat1, lon1, lat2, lon2) => {
  if (!(+lat1 && +lon1 && +lat2 && +lon2)) return null;
  let R = 6371; // Radius of the earth in km
  let milesConversion = 0.621371;
  let dLat = deg2rad(lat2 - lat1);  // deg2rad below
  let dLon = deg2rad(lon2 - lon1);
  let a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c; // Distance in km
  return (d * milesConversion).toFixed(2);
};

export const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};

export const rad2deg = (rad) => {
  return rad * 180 / Math.PI;
};

export const updateProximity = (table) => {
  if (table.length < 2) return table; // no comparable
  let subjectLatitude = table[0][sections.LATITUDE].right.value;
  let subjectLongitude = table[0][sections.LONGITUDE].right.value;
  range(1, table.length).map(index => {
    let compLatitude = table[index][sections.LATITUDE].left.value;
    let compLongitude = table[index][sections.LONGITUDE].left.value;
    let proximity = table[index][sections.PROXIMITY_TO_SUBJECT].left.value.miles;
    const { miles, direction, displayValue, postValue } = getProximityValue(subjectLatitude, subjectLongitude, compLatitude, compLongitude, proximity);
    table[index][sections.PROXIMITY_TO_SUBJECT].left.value.miles = miles;
    table[index][sections.PROXIMITY_TO_SUBJECT].left.value.direction = direction;
    table[index][sections.PROXIMITY_TO_SUBJECT].left.value.displayValue = displayValue;
    table[index][sections.PROXIMITY_TO_SUBJECT].left.value.postValue = postValue;
  });
  return table;
};